import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShopService } from '@app/services/shops/shop.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../../core/services/api/api.service';
import { UserService } from '../../../services/user/user.service';
import { isCustomShopInternationalSettingsEnabled } from '@utils/shop-utils';
import { Router } from '@angular/router';
import { LayoutService } from '@app/storybook/services/layout/layout.service';

@Component({
  selector: 'settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrls: ['./settings-menu.component.scss'],
  standalone: false,
})
export class SettingsMenuComponent implements OnInit, OnDestroy {
  shopSubscription: Subscription;
  shop$: Subject<any> = new Subject<any>();

  settingsOptions = [
    { name: 'Account', displayName: '', url: 'account' },
    { name: 'Order Verification', displayName: '', url: 'verifications' },
    { name: 'Integrations', displayName: 'Integrations', url: 'integrations' },
    { name: 'Delivery services', displayName: 'Delivery services', url: 'delivery-services' },
    { name: 'Checkout', displayName: 'Checkout', url: 'checkout' },
  ];
  locationMenuItem = { name: 'Locations', displayName: '', url: 'locations' };
  plansMenuItem = { name: 'Billing', displayName: '', url: 'billing' };
  internationalMenuItem = { name: 'International', displayName: '', url: 'international' };

  constructor(
    private shopService: ShopService,
    private apiService: ApiService,
    public layoutService: LayoutService,
    private userService: UserService,
    public route: Router,
  ) {}
  ngOnDestroy(): void {
    if (this.shopSubscription) {
      this.shopSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.initShopService();
  }
  initMenu(shop) {
    if (this.userService.isBillingAdmin()) {
      this.settingsOptions = [this.plansMenuItem];
      return;
    }

    if (this.userService.isWrite()) {
      this.settingsOptions.push({ name: 'Users & Permissions', displayName: '', url: 'users-and-permissions' });
    }
    switch (shop.platform) {
      case 'shopify':
      case null:
        this.settingsOptions.push(this.locationMenuItem);
        this.settingsOptions.push(this.plansMenuItem);
        this.settingsOptions.push(this.internationalMenuItem);
        break;
      case 'wix':
        this.settingsOptions.push(this.plansMenuItem);
        break;
      case '3pl-central':
        this.settingsOptions.push(this.locationMenuItem);
        break;
      case 'orderhive':
        this.settingsOptions.push(this.locationMenuItem);
        this.settingsOptions.push(this.internationalMenuItem);
        break;
      case 'shipstation':
        this.settingsOptions.push(this.locationMenuItem);
        break;
      case 'custom':
        this.settingsOptions.push(this.locationMenuItem);
        if (isCustomShopInternationalSettingsEnabled(shop)) {
          this.settingsOptions.push(this.internationalMenuItem);
        }
        break;
    }
    this.settingsOptions.push({ name: 'Notifications', displayName: '', url: 'notifications' });
    if (shop?.metadata?.enablePrintLinkUp) {
      this.settingsOptions.push({ name: 'PDQ Link Up', displayName: '', url: 'link-up' });
    }

    this.settingsOptions.sort((a, b) => a.name.localeCompare(b.name));
    if (String(shop?.metadata?.maxx_external_agent_enabled) === 'true') {
      this.settingsOptions.push({ name: 'MAXX', displayName: '', url: 'maxx' });
    }
  }
  initShopService() {
    // TODO: remove 'false' condition after pushing to  staging
    this.shopSubscription = this.shopService.shop$.pipe(takeUntil(this.shop$)).subscribe((shop) => {
      if (!shop) {
        return;
      }

      this.shop$.next(shop);
      if (shop.metadata?.supportsMeasuresValidation) {
        this.settingsOptions.push({ name: 'Packages', displayName: '', url: 'packages' });
      }

      this.initMenu(shop);
    });
  }
}
